import { render, staticRenderFns } from "./AddFronzen.vue?vue&type=template&id=addc0f10&scoped=true&"
import script from "./AddFronzen.vue?vue&type=script&lang=js&"
export * from "./AddFronzen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addc0f10",
  null
  
)

export default component.exports